import type { GetWorkflowTemplateDeletabilityResponse } from '@ebalance/proto/bffuser/v1/workflow_template_service_pb'

/**
 * 一覧の「削除」を押した時点の行き先 (AC-WFT-061)。
 * `blocked` はモーダルを開かずにバナーで止める。それ以外は削除確認モーダルを開く。
 */
export type DeleteEntry =
  | { kind: 'confirm' }
  | { kind: 'blocked'; ruleCount: number }

/**
 * 削除可否の応答を行き先にする。 未知の case (backend が新しい理由を足した時など) は
 * モーダルを開く側に倒す。 削除するかはモーダルの「削除」で backend がもう一度確かめる。
 */
export function parseDeleteEntry(
  response: GetWorkflowTemplateDeletabilityResponse,
): DeleteEntry {
  const { deletability } = response
  if (deletability.case === 'blockedByAutoCreationRules') {
    return { kind: 'blocked', ruleCount: deletability.value.ruleCount }
  }
  return { kind: 'confirm' }
}
